/* eslint-disable import/prefer-default-export */
export { default as Callbacks } from './Callbacks';


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/callbacks/lib/esm/index.js
// module id = 537
// module chunks = 0 1